import type { GetRequestsListItem } from "@nlc/shared-types";

import { whitelabelRowClassName } from "@/features/requests/constants/accountTags";

import type { TableConfig } from "../../../types/tables";

import { TABLE_LAYOUT_PRESETS } from "../../constants/columnWidths";
import { accountTagsCell } from "../../helpers/accountTagsCell";
import {
  inlineBrandCell,
  inlineComplexityCell,
  inlineDueDateCell,
  inlineStatusCell,
} from "../../helpers/cellRenderers";
import {
  accountCellWithSlotTooltip,
  designTypeCell,
  nameCell,
} from "../../helpers/commonCells";

// Team Requests Tab Configuration for Team Lead
// Columns: Name, Account, Brand, Due, Status, Level, Design Type, Account Tags
export const teamRequestsTableConfig: TableConfig<GetRequestsListItem> = {
  columns: [
    {
      accessor: "name",
      cellRenderer: nameCell,
      header: "Name",
      key: "name",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.name,
    },
    {
      accessor: "account",
      cellRenderer: accountCellWithSlotTooltip,
      header: "Account",
      key: "account",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.account,
    },
    {
      accessor: "dueDate",
      cellRenderer: inlineDueDateCell,
      header: "Due",
      key: "dueDate",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.dueDate,
    },
    {
      accessor: "status",
      cellRenderer: inlineStatusCell,
      header: "Status",
      key: "status",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.status,
    },
    {
      accessor: "complexity",
      cellRenderer: inlineComplexityCell,
      header: "Level",
      key: "complexity",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.complexity,
    },
    {
      accessor: "brand",
      cellRenderer: inlineBrandCell,
      header: "Brand",
      key: "brand",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.brand,
    },
    {
      accessor: "designType",
      cellRenderer: designTypeCell,
      header: "Design Type",
      key: "designType",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.requestType,
    },
    {
      accessor: "account",
      cellRenderer: accountTagsCell,
      header: "Account Tags",
      key: "accountTags",
      sortable: false,
      width: TABLE_LAYOUT_PRESETS.team.accountTags || 120,
    },
  ],
  defaultSort: {
    column: "dueDate",
    direction: "asc",
  },
  getRowClassName: whitelabelRowClassName,
  id: "team-requests",
};
